import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { EditProjectStatus } from '../../../../services/api/project-api';
import { LoginContext } from '../../../../services/api/authentication-api';
import {
    CompleteIcon,
    ReopenIcon,
    ArchiveIcon,
    UnarchiveIcon
} from '../../../../assets/icons.jsx';
import "./new-project-status-change-popup.scss";
import "../../../tasks/scenes/tasks-comments/shared-modal-header.scss";

const NewProjectStatusChangePopupNew = (props) => {
    const [modalTitle, setModalTitle] = useState("");
    const [confirmationStr, setConfirmationStr] = useState("");
    const [warningStr, setWarningStr] = useState("");
    const [actionIcon, setActionIcon] = useState("");
    const [projectStr, setProjectStr] = useState("");
    const [toastStr, setToastStr] = useState("");

    useEffect(() => {
        const plural = `${props?.projects?.length === 1 ? props.labels?.ProjectSingular ?? 'project' : props.labels?.ProjectPlural ?? 'projects'}`;
        const newNumStr = `${props.projects.length} ${props.projects.length == 1 ? props.labels?.ProjectSingular ?? "Project" : props.labels?.ProjectPlural ?? "Projects"}`;

        if (props.type == "Complete") {
            setModalTitle(`Complete ${newNumStr}?`)
            setConfirmationStr(`All active ${props.labels?.TaskPlural ?? "tasks"} in the ${plural} will be cancelled.`);
            setWarningStr(true);
            setActionIcon(CompleteIcon);
            setProjectStr(`Complete ${plural}`);
            setToastStr(" complete");
        } else if (props.type == "Active" && props.popupLabel == "Reopen") {
            setModalTitle(`Reopen ${newNumStr}?`)
            setConfirmationStr(`All ${props.labels?.TaskPlural ?? "tasks"} in the ${plural} will keep their current status.`);
            setWarningStr(false);
            setActionIcon(ReopenIcon);
            setProjectStr(`Reopen ${plural}`);
            setActionIcon(ReopenIcon);
            setToastStr(" reopen");
        } else if (props.type == "Active" && props.popupLabel == "Unarchive") {
            setModalTitle(`Unarchive ${newNumStr}?`)
            setConfirmationStr(`All ${props.labels?.TaskPlural ?? "tasks"} in the ${plural} will return to their previous status.`);
            setWarningStr(false);
            setActionIcon(UnarchiveIcon);
            setProjectStr(`Unarchive ${plural}`);
            setToastStr(" unarchive");
        } else if (props.type == "Archive") {
            setModalTitle(`Archive ${newNumStr}?`)
            setConfirmationStr(`All ${props.labels?.TaskPlural ?? "tasks"} in the ${plural} will be archived.`);
            setWarningStr(false);
            setActionIcon(ArchiveIcon);
            setProjectStr(`Archive ${plural}`);
            setToastStr(" archive");
        }
    }, [props.type, props.popupLabel, props.projects.length]);

    const submitAction = async () => {
        await props.projects.forEach(async (project) => {
            let newProject = { ...project };
            newProject.StatusId = props.status;

            await EditProjectStatus(newProject).then(
                (result) => {
                    props.refreshTable(false);
                    props.onEdit(false, result, newProject.Name, toastStr);
                },
                (error) => {
                    props.onEdit(true, error);
                }
            );
        })
        props.onHide();
    };

    return(
        <LoginContext.Consumer>
            {
                (state) => (
                    <div onClick={(e) => e.stopPropagation()}>
                        <Modal show={props.show} onHide={props.onHide} className="new-project-status-change-popup tasks-actions-popup">
                            <Modal.Header className="header-popup" closeButton>
                                <Modal.Title className={props.new ? "actions-title-new" : "actions-title"}>
                                    {modalTitle}
                                </Modal.Title>
                            </Modal.Header>
                            <div className="select-member-divider-line"></div>
                            <Modal.Body>
                                <img className="complete-icon" src={actionIcon} alt="Complete"/>
                                  <h3 className="actions-task-name-center">{confirmationStr}</h3>
                                  <h3 className="actions-task-name-center warning">
                                    {   warningStr ? (<span>Note: This action cannot be undone.</span>) : "" }
                                  </h3>
                                  <div className="d-flex justify-content-between" style={{marginTop: "32px"}}>
                                    <button className="tertiary-btn"  onClick={props.onHide}>No, Go Back</button>
                                    <button className="primary-btn" onClick={submitAction}>Yes, {projectStr}</button>
                                  </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                )
            }
        </LoginContext.Consumer>
    )
}

NewProjectStatusChangePopupNew.contextType = LoginContext;

NewProjectStatusChangePopupNew.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func,
    projects: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    popupLabel: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    refreshTable: PropTypes.func,
    onEdit: PropTypes.func,
    new: PropTypes.bool,
    labels: PropTypes.shape({
        ProjectSingular: PropTypes.string,
        ProjectPlural: PropTypes.string,
    }),
};

export default NewProjectStatusChangePopupNew;